var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2784_112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7123 20.4913L16.5407 17.6629L17.9549 19.0771L13.7123 23.3197L8.05544 17.6629L9.46966 16.2487L13.7123 20.4913ZM19.3692 14.8344L16.5407 17.6629L15.1265 16.2487L17.9549 13.4202L19.3692 14.8344ZM20.7834 10.5918L17.9549 13.4202L16.5407 12.006L19.3692 9.17758L20.7834 10.5918ZM22.1976 6.34916L19.3692 9.17758L17.9549 7.76337L20.7834 4.93494L22.1976 6.34916ZM13.7123 12.006L9.46966 16.2487L8.05544 14.8344L12.2981 10.5918L13.7123 12.006ZM22.1976 3.52073L20.7834 4.93494L19.3692 3.52073L20.7834 2.10652L22.1976 3.52073ZM6.64123 7.76337L3.8128 10.5918L8.05544 14.8344L6.64123 16.2487L0.984375 10.5918L5.22702 6.34916L6.64123 7.76337ZM19.3692 3.52073L16.5407 6.34916L15.1265 4.93494L17.9549 2.10652L19.3692 3.52073ZM15.1265 4.93494L12.2981 7.76337L10.8839 6.34916L13.7123 3.52073L15.1265 4.93494ZM10.8839 6.34916L8.05544 9.17758L6.64123 7.76337L9.46966 4.93494L10.8839 6.34916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7123 20.4913L16.5407 17.6629L15.1265 16.2487L17.9549 13.4202L16.5407 12.006L19.3692 9.17758L17.9549 7.76337L20.7834 4.93494L19.3692 3.52073L16.5407 6.34916L15.1265 4.93494L12.2981 7.76337L10.8839 6.34916L8.05544 9.17758L6.64123 7.76337L3.8128 10.5918L8.05544 14.8344L12.2981 10.5918L13.7123 12.006L9.46966 16.2487L13.7123 20.4913Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2784_112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmail);
export default __webpack_public_path__ + "static/media/sendmail.498ba89ebbec8db3756f37997e6d22b8.svg";
export { ForwardRef as ReactComponent };